var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.004 512.004",
    style: {
      enableBackground: "new 0 0 512.004 512.004"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M495.622,447.14H44.76l86.432-149.712c43.001,29.76,72.984,75.063,83.199,126.54c1.544,7.801,8.395,13.188,16.054,13.188 c1.056,0,2.13-0.106,3.204-0.311c8.875-1.766,14.643-10.383,12.877-19.258c-12.063-60.728-47.763-114.051-98.92-148.592 L270.186,56.67c4.526-7.828,1.837-17.847-5.999-22.373c-7.836-4.526-17.847-1.837-22.373,5.999L2.196,455.331 c-2.929,5.067-2.929,11.315,0,16.383c2.929,5.059,8.342,8.191,14.191,8.191h479.235c9.043,0,16.383-7.331,16.383-16.383 C512.004,454.47,504.674,447.14,495.622,447.14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle);
export default __webpack_public_path__ + "static/media/angle.8dbee74be21018a86e29434ba3ca2e61.svg";
export { ForwardRef as ReactComponent };